import ImageGroq from './ImageGroq';

export default `{
  "type": _type,
  url,
  "image": image${ImageGroq},
  ...
}`;
